export const PREFECTURES = [
  { id: "01", label: "北海道" }, { id: "02", label: "青森県" }, { id: "03", label: "岩手県" }, { id: "04", label: "宮城県" },
  { id: "05", label: "秋田県" }, { id: "06", label: "山形県" }, { id: "07", label: "福島県" }, { id: "08", label: "茨城県" },
  { id: "09", label: "栃木県" }, { id: "10", label: "群馬県" }, { id: "11", label: "埼玉県" }, { id: "12", label: "千葉県" },
  { id: "13", label: "東京都" }, { id: "14", label: "神奈川県" }, { id: "15", label: "新潟県" }, { id: "16", label: "富山県" },
  { id: "17", label: "石川県" }, { id: "18", label: "福井県" }, { id: "19", label: "山梨県" }, { id: "20", label: "長野県" },
  { id: "21", label: "岐阜県" }, { id: "22", label: "静岡県" }, { id: "23", label: "愛知県" }, { id: "24", label: "三重県" },
  { id: "25", label: "滋賀県" }, { id: "26", label: "京都府" }, { id: "27", label: "大阪府" }, { id: "28", label: "兵庫県" },
  { id: "29", label: "奈良県" }, { id: "30", label: "和歌山県" }, { id: "31", label: "鳥取県" }, { id: "32", label: "島根県" },
  { id: "33", label: "岡山県" }, { id: "34", label: "広島県" }, { id: "35", label: "山口県" }, { id: "36", label: "徳島県" },
  { id: "37", label: "香川県" }, { id: "38", label: "愛媛県" }, { id: "39", label: "高知県" }, { id: "40", label: "福岡県" },
  { id: "41", label: "佐賀県" }, { id: "42", label: "長崎県" }, { id: "43", label: "熊本県" }, { id: "44", label: "大分県" },
  { id: "45", label: "宮崎県" }, { id: "46", label: "鹿児島県" }, { id: "47", label: "沖縄県" }
];

export const CONSULTATION_CONTENTS = [
  { value: "mindBodyIssues", label: "からだや心についての悩みについて" },
  { value: "sexualAdolescent", label: "性に関する相談・思春期の健康相談について" },
  { value: "emergencyPill", label: "緊急避妊について" },
  { value: "unexpectedPregnancy", label: "予期していない妊娠について" },
  { value: "maternityCare", label: "妊娠・出産・産後について" },
  { value: "genderBasedViolence", label: "DVや性被害など性暴力について" },
  { value: "stdConsultation", label: "性感染症について" },
  { value: "womensHealth", label: "婦人科の病気について" },
  { value: "fertilityIssues", label: "不妊について" },
  { value: "climactericDisorder", label: "更年期障害について" },
  { value: "generalInquiries", label: "その他" }
];

export const CONSULTATION_METHODS = [
  { value: "interviewReceptionHours", label: "対面による面談" },
  { value: "phoneReceptionHours", label: "電話相談" },
  { value: "snsReceptionHours", label: "SNS相談/LINE相談" },
  { value: "mailReceptionHours", label: "メール相談" },
  { value: "visitReceptionHours", label: "訪問相談" },
  { value: "etcReceptionHours", label: "その他" }
];

// 2段階都道府県選択用の地域グループ
export const PREFECTURE_REGIONS = [
  {
    id: "hokkaido-tohoku",
    label: "北海道・東北",
    prefectures: [
      { id: "01", label: "北海道" },
      { id: "02", label: "青森県" },
      { id: "03", label: "岩手県" },
      { id: "04", label: "宮城県" },
      { id: "05", label: "秋田県" },
      { id: "06", label: "山形県" },
      { id: "07", label: "福島県" }
    ]
  },
  {
    id: "kanto",
    label: "関東",
    prefectures: [
      { id: "08", label: "茨城県" },
      { id: "09", label: "栃木県" },
      { id: "10", label: "群馬県" },
      { id: "11", label: "埼玉県" },
      { id: "12", label: "千葉県" },
      { id: "13", label: "東京都" },
      { id: "14", label: "神奈川県" }
    ]
  },
  {
    id: "chubu",
    label: "中部",
    prefectures: [
      { id: "15", label: "新潟県" },
      { id: "16", label: "富山県" },
      { id: "17", label: "石川県" },
      { id: "18", label: "福井県" },
      { id: "19", label: "山梨県" },
      { id: "20", label: "長野県" },
      { id: "21", label: "岐阜県" },
      { id: "22", label: "静岡県" },
      { id: "23", label: "愛知県" }
    ]
  },
  {
    id: "kinki",
    label: "近畿",
    prefectures: [
      { id: "24", label: "三重県" },
      { id: "25", label: "滋賀県" },
      { id: "26", label: "京都府" },
      { id: "27", label: "大阪府" },
      { id: "28", label: "兵庫県" },
      { id: "29", label: "奈良県" },
      { id: "30", label: "和歌山県" }
    ]
  },
  {
    id: "chugoku",
    label: "中国",
    prefectures: [
      { id: "31", label: "鳥取県" },
      { id: "32", label: "島根県" },
      { id: "33", label: "岡山県" },
      { id: "34", label: "広島県" },
      { id: "35", label: "山口県" }
    ]
  },
  {
    id: "shikoku",
    label: "四国",
    prefectures: [
      { id: "36", label: "徳島県" },
      { id: "37", label: "香川県" },
      { id: "38", label: "愛媛県" },
      { id: "39", label: "高知県" }
    ]
  },
  {
    id: "kyushu-okinawa",
    label: "九州・沖縄",
    prefectures: [
      { id: "40", label: "福岡県" },
      { id: "41", label: "佐賀県" },
      { id: "42", label: "長崎県" },
      { id: "43", label: "熊本県" },
      { id: "44", label: "大分県" },
      { id: "45", label: "宮崎県" },
      { id: "46", label: "鹿児島県" },
      { id: "47", label: "沖縄県" }
    ]
  }
];

export const CONSULTATION_LINKS = [
  {
    title: "性や妊娠などの悩みについての相談窓口",
    org: "(こども家庭庁)",
    link: "/soudan/nayami/"
  },
  {
    title: "緊急避妊のための診療を受けられる産婦人科",
    org: "(厚生労働省)",
    link: "/soudan/sanfujinka/"
  },
  {
    title: "性犯罪・性暴力・配偶者からの暴力（DV）について",
    org: "(内閣府・警察庁)",
    link: "/soudan/dv/"
  },
  {
    title: "感染症・予防接種などの厚生労働省電話相談窓口",
    org: "(厚生労働省)",
    link: "/soudan/telephone/"
  }
];

export const SNS_LINKS = {
  instagram: "https://www.instagram.com/precon_cfa_jp/",
  youtube: "https://www.youtube.com/channel/UCrZTsGTeQummeb-R6rwKZxA"
} as const;